import React from 'react';
import { Progress, ResponseErrorPanel } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { MLFlowContent } from './MLFlowContent';
import { useMLFlowData } from './hooks';

export const MLFlowComponent = () => {
  const { entity } = useEntity();
  
  const { value, loading, error } = useMLFlowData(entity);

  if (loading) {
    return <Progress />;
  }
  
  if (error) {
    return <ResponseErrorPanel error={error} />;
  }

  if (!value?.mlFlowModelDetail) {
    return <ResponseErrorPanel error={new Error('Failed to load MLFlow model details')} />;
  }

  return <MLFlowContent mlFlowModelDetail={value.mlFlowModelDetail} entity={entity} />;
};
